import { PropTypes, React, styled } from '../../lib/imports';
import { Image, Text } from '../../components';
import { getAssetSet, useCdnImage, useCdnUrl } from '../../app/context/config';

const HeatStreakBannerWrapper = styled.div`
  display: flex;
  margin-top: ${({ theme }) => theme.spacings.mega};
  padding: ${({ theme }) => theme.spacings.mega} ${({ theme }) => theme.spacings.mega} 0;
  overflow: hidden;
  background-image: url(${({ backgroundImage }) => backgroundImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const TextWrapper = styled.div`
  margin-left: ${({ theme }) => theme.spacings.giga};
  padding-bottom: ${({ theme }) => theme.spacings.mega};
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const BannerImage = styled(Image)`
  max-width: 100px;
  box-shadow: 0 0 40px 0 #ff2020;
  margin-bottom: -5px;
`;

const Title = styled.div`
  font-size: ${({ theme }) => theme.typography.text.tera.fontSize};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.white};
`;

const MainText = styled.div`
  font-size: ${({ theme }) => theme.typography.text.giga.fontSize};
  color: ${({ theme }) => theme.colors.white};
`;

const Terms = styled(Text)`
  font-size: ${({ theme }) => theme.typography.text.giga.fontSize};
  color: ${({ theme }) => theme.colors.white};
  a {
    color: ${({ theme }) => theme.colors.white};
  }
`;

const MainTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
`;

export const HeatStreakInfoBanner = ({ imageSrc, title, text, disclaimerTerms }) => {
  const cdnUrl = useCdnUrl();
  const backgroundImageUrl = getAssetSet(useCdnImage, 'heatstreakBannerBackground');

  return (
    <HeatStreakBannerWrapper backgroundImage={backgroundImageUrl}>
      <BannerImage src={`${cdnUrl}${imageSrc}`} />
      <TextWrapper>
        <Title>{title}</Title>
        <MainTextWrapper>
          <MainText>{text}</MainText>
          <Terms>{disclaimerTerms}</Terms>
        </MainTextWrapper>
      </TextWrapper>
    </HeatStreakBannerWrapper>
  );
};

HeatStreakInfoBanner.propTypes = {
  imageSrc: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  disclaimerTerms: PropTypes.string,
};
